import React, { useState, useEffect } from "react";
import { Button, Table, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import action_icon_1 from "../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../Assets/svg/tableData/action-icon-2.svg";
import { del } from "../../../../helpers/api_helper";
import AddNewPlan from "./Modal/AddNewPlan";
import DeleteConfirmationModal from "../../../../components/DeleteConfirmation";
import { useSelector } from "react-redux";
import useCheckPermission from "../../../../hooks/useCheckPermission";
import { PLAN_DELETE } from "../../../../helpers/url_helper";

const PlanTableData = ({ planData, setRefresh }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [planToDelete, setPlanToDelete] = useState(null);

  const hasUpdatePermission = useCheckPermission("subscription", "UPDATE");
  const hasDeletePermission = useCheckPermission("subscription", "DELETE");

  useEffect(() => {
    // Check if planData is loaded
    setLoading(false);
  }, [planData]);

  const handleDelete = async () => {
    try {
      const response = await del(`${PLAN_DELETE}/${planToDelete}`);
      if (response.success) {
        setRefresh(true);
        toast.success("Plan deleted successfully");
      } else {
        console.log(response.message);
        // toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      // toast.error(error.message);
    } finally {
      setShowConfirm(false);
    }
  };

  const confirmDelete = (id) => {
    setPlanToDelete(id);
    setShowConfirm(true);
  };

  const handleEdit = (plan) => {
    setSelectedPlan(plan);
    setModalMode("edit");
    setShowModal(true);
  };

  return (
    <>
      <AddNewPlan
        show={showModal}
        onHide={() => setShowModal(false)}
        mode={modalMode}
        planData={selectedPlan}
        setRefresh={() => setRefresh(true)}
      />

      <DeleteConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleDelete}
      />

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Table responsive>
          <thead>
            <tr>
              <th className="fw-normal">Plan Name</th>
              <th className="fw-normal">Plan Price</th>
              <th className="fw-normal">Plan Duration</th>
              <th className="fw-normal">Free Trial</th>
              <th className="fw-normal">Status</th>
              <th className="fw-normal">Action</th>
            </tr>
          </thead>
          <tbody>
            {planData && planData.length > 0 ? (
              planData?.map((plan) => (
                <tr key={plan._id}>
                  <td className="text-capitalize">{plan.name}</td>
                  <td>{`$ ${plan.price}`}</td>
                  <td>
                    {plan.duration === 1
                      ? `${plan.duration} Month`
                      : `${plan.duration} Months`}
                  </td>
                  <td className="text-capitalize">{plan.free_trial}</td>
                  <td>{plan.status}</td>
                  <td>
                    <div className="d-flex align-items-center gap-10">
                      {hasUpdatePermission && <Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => handleEdit(plan)}
                      >
                        <img src={action_icon_1} alt="Edit" />
                      </Button>}
                      {hasDeletePermission && <Button
                        className="border-0 p-0 text-danger"
                        variant="transparent"
                        onClick={() => confirmDelete(plan._id)}
                      >
                        <img src={action_icon_2} alt="Delete" />
                      </Button>}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default PlanTableData;
